import { dateFormatMap, dateTypeMap } from '@op/constants';
import { formatTime } from '../../render-helper';
import { mentionsSentimentRenderHelperFuncMap } from '@op/pages/Overview/CompareKeyMetrics/constants';

export default function (params: any) {
  let { by_type, tab_type, date_type } = params;
  const formatFunc =
    mentionsSentimentRenderHelperFuncMap?.[by_type || tab_type] || {};
  const valueColumns: { [key: string]: string } = {
    google_trends: 'Google Trends',
  };

  return [
    {
      header: 'Date',
      render: 'time',
      renderHelper: [formatTime(dateFormatMap[dateTypeMap[date_type]])],
    },
    {
      header: valueColumns?.[by_type || tab_type],
      render: 'value',
      ...formatFunc,
    },
  ];
}
